// A file's preview, fetched from the Mac by path (docs/features/session-files.md): the window `macfile`, opened by a
// path tapped in a reply (`mdfile:`), a display pane's `file` element, or an attachment. Arg {path, directory, session}.
import { registerWindow } from '../../core/windows.js'

registerWindow('macfile', { module: () => import('./macfile.js'), css: 'windows/macfile/macfile.css', key: (a, key) => 'macfile-' + (key || 'mac') + '-' + (a?.path || ''), title: (a) => String(a?.path || 'File').split('/').pop(), place: ['session', 'trailing'] })
